import "VSS/LoaderPlugins/Css!Controls/Links/DevelopmentZeroDataComponent";
import * as React from "react";
import { BaseComponent, IBaseProps } from "OfficeFabric/Utilities";
import { RegisteredLinkTypeNames } from "WorkItemTracking/Scripts/RegisteredLinkTypeNames";
import * as Resources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking";
import { Link } from "VSSUI/Link";
import { publishEvent, TelemetryEventData } from "VSS/Telemetry/Services";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { Image } from "VSSUI/Image";
import { IVssLocationService } from "VSS/Platform/Location";
import { getLWPService } from "VSS/LWP";
import { DevelopmentZeroDataSettingsResponse } from "TFS/WorkItemTracking/DataProviderContracts";

export interface IDevelopmentZeroDataProps extends IBaseProps {
    actionCallback: (type: string) => void;
    createBranchActionCallback: () => void;
    zeroDataSettings: DevelopmentZeroDataSettingsResponse;
}

const GitHubAzureBoardsDocUrl = "https://aka.ms/azureboardsgithub/devctrl";

export class DevelopmentZeroDataComponent extends BaseComponent<IDevelopmentZeroDataProps> {
    private _repoImageUrl: string;

    constructor(props: IDevelopmentZeroDataProps) {
        super(props);
        const locationService = getLWPService<IVssLocationService>("IVssLocationService");
        this._repoImageUrl = locationService.getAssetLocation("ms.vss-code-web/common-content/Nav-Code.png");
    }

    public render(): JSX.Element {
        const { zeroDataSettings } = this.props;
        return (
            <div>
                {zeroDataSettings.showGitHubZeroDataExperience ? (
                    <div className="zero-data-action github">
                        <div>
                            <VssIcon className="zero-data-icon" iconName="GitHubLogo" iconType={VssIconType.fabric} />
                        </div>
                        {zeroDataSettings.showGitHubPromoteZeroDataExperience ? this._getGitHubPromoteZeroDataText() : this._getGitHubZeroDataText()}
                    </div>
                ) : null}
                {zeroDataSettings.showAzureReposZeroDataExperience ? (
                    <div className="zero-data-action">
                        <div>
                            <Image className="zero-data-icon" src={this._repoImageUrl} alt={Resources.ZeroDataImageAltText} />
                        </div>
                        {this._getAzureReposZeroDataText()}
                    </div>
                ) : null}
            </div>
        );
    }

    private _getGitHubZeroDataText(): JSX.Element {
        return (
            <div>
                <span>{Resources.GitHubZeroDataText1}</span>
                <Link onClick={this._onGitHubCommitClick}>{Resources.GitHubZeroDataCommitLinkTypeText}</Link>
                <span>{Resources.GitHubZeroDataText2}</span>
                <Link onClick={this._onGitHubPullRequestClick}>{Resources.GitHubZeroDataPullRequestTypeText}</Link>
                <span>{Resources.GitHubZeroDataText3}</span>
                <Link href={GitHubAzureBoardsDocUrl} target="_blank">
                    {Resources.NewFeatureLearnMoreLinkTitle}
                </Link>
            </div>
        );
    }

    private _getGitHubPromoteZeroDataText(): JSX.Element {
        return (
            <div>
                <span>{Resources.GitHubPromoteZeroDataText1}</span>
                <Link href={GitHubAzureBoardsDocUrl} target="_blank">
                    {Resources.GitHubPromoteZeroDataText2}
                </Link>
                <span>{Resources.GitHubZeroDataText3}</span>
            </div>
        );
    }

    private _getAzureReposZeroDataText(): JSX.Element {
        return (
            <div>
                <span>{Resources.AzureReposZeroDataText1}</span>
                <Link onClick={this._onReposCommitClick}>{Resources.GitHubZeroDataCommitLinkTypeText}</Link>
                <span>, </span>
                <Link onClick={this._onReposPullRequestClick}>{Resources.GitHubZeroDataPullRequestTypeText}</Link>
                <span>{Resources.GitHubZeroDataText2}</span>
                <Link onClick={this._onReposBranchClick}>{Resources.LinksControlZeroDataBranchText}</Link>
                <span>
                    {Resources.GitHubZeroDataText3}
                    {Resources.AzureReposZeroDataText2}
                </span>
                <Link onClick={this._onReposCreateBranchClick}>{Resources.CreateaBranchText}</Link>
                <span>{Resources.AzureReposZeroDataText3}</span>
            </div>
        );
    }

    private _onGitHubCommitClick = () => {
        if (this.props.actionCallback) {
            this.props.actionCallback(Resources.LinksControlGitHubCommitText);
            this._publishTelemetry(RegisteredLinkTypeNames.GitHubCommitLinkType);
        }
    }

    private _onGitHubPullRequestClick = () => {
        if (this.props.actionCallback) {
            this.props.actionCallback(Resources.LinksControlGitHubPullRequestText);
            this._publishTelemetry(RegisteredLinkTypeNames.GitHubPullRequestLinkType);
        }
    }

    private _onReposCommitClick = () => {
        if (this.props.actionCallback) {
            this.props.actionCallback(Resources.LinksControlCommitText);
            this._publishTelemetry(RegisteredLinkTypeNames.Commit);
        }
    }

    private _onReposPullRequestClick = () => {
        if (this.props.actionCallback) {
            this.props.actionCallback(Resources.LinksControlPullRequestText);
            this._publishTelemetry(RegisteredLinkTypeNames.PullRequest);
        }
    }

    private _onReposBranchClick = () => {
        if (this.props.actionCallback) {
            this.props.actionCallback(Resources.LinksControlBranchText);
            this._publishTelemetry(RegisteredLinkTypeNames.Branch);
        }
    }

    private _onReposCreateBranchClick = () => {
        if (this.props.createBranchActionCallback) {
            this.props.createBranchActionCallback();
            this._publishTelemetry(Resources.CreateaBranchText);
        }
    }

    private _publishTelemetry(type: string) {
        publishEvent(new TelemetryEventData("LinksControl", "AddLink", { type }));
    }
}
